import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 10 10",
  height: "48",
  width: "48",
  xmlns: "http://www.w3.org/2000/svg",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M2.99,9.375a1.713,1.713,0,0,1-1.321-.619L.161,6.839a.75.75,0,1,1,1.178-.928l1.5,1.9a.16.16,0,0,0,.158.063.217.217,0,0,0,.17-.082L8.664.907a.75.75,0,1,1,1.172.936L4.329,8.735A1.717,1.717,0,0,1,3,9.375Z",
      fill: "currentColor",
      stroke: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "0"
    }, null, -1)
  ])))
}
export default { render: render }